import { useState, useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import { Typography, Grid, TextField, Card, Stack, Button, Container, CardContent } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
import { ResetSettingsListAction, ResetUpdateSettingsAction, SettingsListAction, UpdateSettingsAction } from 'src/redux/actions/SettingsAction';
import { toast } from 'react-toastify';


export default function SubAdminList() {
    const dispatch = useDispatch();
    const settingSelector = useSelector(state => state.settings.setting_list)
    const settingData = settingSelector && settingSelector?.data?.data
    const settingUpdateSelector = useSelector(state => state.settings.setting_update)
    const [state, setState] = useState({
        email: "",
        full_address: "",
        mobile: "",
        usable_bonus_percentage: "",
        bonus_amount: "",
        admin_commission: "",
        min_withdraw_amount: "",
        tds: "",
        player_acc: "",
        team_acc: "",
        prize_pool: "",
        platform_fees: "",
        ref_bns_amt:0,
        add_amt_bonus_perc:0,
        gst_addamount_percentage:0,
        android_version:"",
        ios_version:""
    });

    useEffect(() => {
        dispatch(SettingsListAction())
        return () => dispatch(ResetSettingsListAction())
    }, [dispatch])

    useEffect(() => {
        if (settingData) {
            setState({
                email: settingData.email,
                full_address: settingData.full_address,
                mobile: settingData.mobile,
                usable_bonus_percentage: settingData.usable_bonus_percentage,
                bonus_amount: settingData.bonus_amount,
                admin_commission: settingData.admin_commission,
                min_withdraw_amount: settingData.min_withdraw_amount,
                tds: settingData.tds,
                player_acc: settingData.player_acc,
                team_acc: settingData.team_acc,
                prize_pool: settingData.prize_pool,
                platform_fees: settingData.platform_fees,
                ref_bns_amt:settingData.ref_bns_amt,
                add_amt_bonus_perc:settingData.add_amt_bonus_perc,
                gst_addamount_percentage:settingData.gst_addamount_percentage,
                android_version:settingData.android_version,
                ios_version:settingData.ios_version
            })
        }
    }, [settingData])

    const stateHandler = (key, value) => {
        state[key] = value;
        setState({ ...state });
    };

    const handleSettingSubmit = (e) => {
        e.preventDefault();
        dispatch(UpdateSettingsAction(state))
    }

    useEffect(() => {
        if (Object.keys(settingUpdateSelector).length > 0) {
            if (settingUpdateSelector.data.status) {
                toast.success(settingUpdateSelector.data.message)
                dispatch(ResetUpdateSettingsAction())
            }
        }
    }, [settingUpdateSelector])

    return (
        <Page title="User">
            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Settings"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Settings' }
                    ]}
                />

                <Card>
                    <CardContent>
                        <form autoComplete="off" onSubmit={handleSettingSubmit}>
                            <Grid container spacing={2}>
                                <Grid item md={12}>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ marginTop: 20 }}
                                        variant="h6"
                                        component="h2"
                                    > Personal Settings </Typography>
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("email", target.value)}
                                        type="email"
                                        label="Admin Email"
                                        variant="outlined"
                                        value={state.email}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("mobile", target.value)}
                                        type="number"
                                        label="Admin Number"
                                        variant="outlined"
                                        value={state.mobile}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("full_address", target.value)}
                                        type="text"
                                        label="Admin Full Address"
                                        variant="outlined"
                                        value={state.full_address}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ marginTop: 20 }}
                                        variant="h6"
                                        component="h2"
                                    > Common Settings </Typography>
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("bonus_amount", target.value)}
                                        type="number"
                                        label="Welcome Bouns Amount (INR)"
                                        variant="outlined"
                                        value={state.bonus_amount}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("usable_bonus_percentage", target.value)}
                                        type="number"
                                        label="Usable Bonus Percentage"
                                        variant="outlined"
                                        value={state.usable_bonus_percentage}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("min_withdraw_amount", target.value)}
                                        type="number"
                                        label="Minimum Withdraw Amount (INR)"
                                        variant="outlined"
                                        value={state.min_withdraw_amount}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                

                                

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("tds", target.value)}
                                        type="number"
                                        label="TDS (In percentage)"
                                        variant="outlined"
                                        value={state.tds}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("ref_bns_amt", target.value)}
                                        type="number"
                                        label="Refer Bonus"
                                        variant="outlined"
                                        value={state.ref_bns_amt}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("add_amt_bonus_perc", target.value)}
                                        type="number"
                                        label="Add Amount Bonus Percentage"
                                        variant="outlined"
                                        value={state.add_amt_bonus_perc}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("gst_addamount_percentage", target.value)}
                                        type="number"
                                        label="GST Add Amount Percentage"
                                        variant="outlined"
                                        value={state.gst_addamount_percentage}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                <Grid item md={12}>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ marginTop: 20 }}
                                        variant="h6"
                                        component="h2"
                                    > For Mobile Developer only </Typography>
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("android_version", target.value)}
                                        type="text"
                                        label="Android Version"
                                        variant="outlined"
                                        value={state.android_version}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("ios_version", target.value)}
                                        type="text"
                                        label="IOS Version"
                                        variant="outlined"
                                        value={state.ios_version}
                                        fullWidth
                                        required
                                    />
                                </Grid>



                                <Grid item md={12}>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ marginTop: 20 }}
                                        variant="h6"
                                        component="h2"
                                    > Accumulator Settings </Typography>
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("player_acc", target.value)}
                                        type="number"
                                        label="Player Accumulator Amount"
                                        variant="outlined"
                                        value={state.player_acc}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("team_acc", target.value)}
                                        type="number"
                                        label="Team Accumulator Amount"
                                        variant="outlined"
                                        value={state.team_acc}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("prize_pool", target.value)}
                                        type="number"
                                        label="Prize Pool Amount"
                                        variant="outlined"
                                        value={state.prize_pool}
                                        fullWidth
                                        required
                                    />
                                </Grid>

                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("platform_fees", target.value)}
                                        type="number"
                                        label="Platform Fee (In percentage)"
                                        variant="outlined"
                                        value={state.platform_fees}
                                        fullWidth
                                        required
                                    />
                                </Grid>


                                <Grid item md={12}>
                                    <Typography
                                        id="modal-modal-title"
                                        style={{ marginTop: 20 }}
                                        variant="h6"
                                        component="h2"
                                    > Contest Settings </Typography>
                                </Grid>
                                <Grid item md={6}>
                                    <TextField
                                        onChange={({ target }) => stateHandler("admin_commission", target.value)}
                                        type="number"
                                        label="Admin Contest Commission (In percentage)"
                                        variant="outlined"
                                        value={state.admin_commission}
                                        fullWidth
                                        required
                                    />
                                </Grid>
                                

                                <Grid item md={12}>
                                    </Grid>
                                <Grid item md={6}>
                                    <Button
                                        align={"center"}
                                        style={{ marginTop: 20, width: "100%" }}
                                        variant="contained"
                                        type="submit"
                                        size="large"
                                    >
                                        Submit
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
}
